import { firebase } from '../config/configureFirebase';
import store from '../store/store';

let appCheckTokenProvider = null;

export const setAppCheckTokenProvider = (provider) => {
    appCheckTokenProvider = typeof provider === 'function' ? provider : null;
};

export const getSecureFunctionHost = (config, settings) => {
    if (typeof window !== 'undefined' && window.location && settings?.CompanyWebsite === window.location.origin) {
        return window.location.origin;
    }
    return `https://${config.projectId}.web.app`;
};

export const callSecureFunction = async (path, body) => {
    const { auth, config } = firebase;
    const settings = store.getState().settingsdata.settings;
    const user = auth.currentUser;
    if (!user) {
        throw new Error('Not authenticated');
    }
    const token = await user.getIdToken();
    const host = getSecureFunctionHost(config, settings);
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    };
    if (appCheckTokenProvider) {
        try {
            const appCheckToken = await appCheckTokenProvider();
            if (appCheckToken) {
                headers['X-Firebase-AppCheck'] = appCheckToken;
            }
        } catch (e) { /* noop */ }
    }
    const res = await fetch(`${host}/${path}`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
    });
    let json = {};
    try {
        json = await res.json();
    } catch (e) {
        json = {};
    }
    if (!res.ok) {
        const err = new Error(json.error || 'request_failed');
        err.code = json.error;
        err.details = json;
        throw err;
    }
    return json;
};
